module.exports = __webpack_public_path__ + "static/media/arrow-green-right.bd95fa88.svg";